import { apiService } from './apiService';

export const accountingService = {
  async getDriverShipments() {
    return apiService.get('/accounting/driver/my-shipments');
  },

  async completeDelivery(shipmentId: string | number, data?: { waitingFee?: number; beklemeFee?: number; hammaliyeFee?: number; genelToplam?: number }) {
    return apiService.post(`/accounting/shipments/${shipmentId}/complete-delivery`, data || {});
  },

  async submitInvoice(shipmentId: string | number, data: any) {
    return apiService.post(`/accounting/shipments/${shipmentId}/submit-invoice`, data);
  },

  async getOverview(stage?: string) {
    const query = stage ? `?stage=${encodeURIComponent(stage)}` : '';
    return apiService.get(`/accounting/overview${query}`, { timeoutMs: 180000 });
  },

  async bulkSubmitInvoice(formData: FormData) {
    const baseUrl = import.meta.env.VITE_API_URL || 'http://localhost:5000/api';
    const token = localStorage.getItem('authToken');

    const response = await fetch(`${baseUrl}/accounting/shipments/bulk-submit-invoice`, {
      method: 'POST',
      headers: token ? { Authorization: `Bearer ${token}` } : undefined,
      body: formData,
    });

    const data = await response.json();
    if (!response.ok) {
      throw new Error(data.message || 'Toplu fatura yuklenemedi');
    }
    return data;
  },

  async repairInvoiceLinks() {
    return apiService.post('/accounting/shipments/repair-invoice-links', {});
  },

  async approveDelivery(shipmentId: string | number) {
    return apiService.post(`/accounting/shipments/${shipmentId}/approve-delivery`, {});
  },

  async rejectDelivery(shipmentId: string | number, reason: string) {
    return apiService.post(`/accounting/shipments/${shipmentId}/reject-delivery`, { reason });
  },

  async approveInvoice(shipmentId: string | number) {
    return apiService.post(`/accounting/shipments/${shipmentId}/approve-invoice`, {});
  },

  async approveInvoiceCheck(shipmentId: string | number) {
    return apiService.post(`/accounting/shipments/${shipmentId}/approve-invoice-check`, {});
  },

  async generatePreApprovalPackage(shipmentId: string | number) {
    return apiService.post(`/accounting/shipments/${shipmentId}/generate-pre-approval-package`, {}, { timeoutMs: 300000 });
  },

  async bulkGeneratePreApprovalPackages(shipmentIds: Array<string | number>) {
    return apiService.post('/accounting/shipments/bulk-generate-pre-approval-packages', { shipmentIds }, { timeoutMs: 900000 });
  },

  async queuePreApprovalSign(shipmentId: string | number) {
    return apiService.post(`/accounting/shipments/${shipmentId}/queue-pre-approval-sign`, {});
  },

  async bulkQueuePreApprovalSign(shipmentIds: Array<string | number>) {
    return apiService.post('/accounting/shipments/bulk-queue-pre-approval-sign', { shipmentIds });
  },

  async bulkResetPreApprovalSign(shipmentIds: Array<string | number>) {
    return apiService.post('/accounting/shipments/bulk-reset-pre-approval-sign', { shipmentIds });
  },

  async getPreApprovalSignStatuses(shipmentIds: Array<string | number>) {
    const query = shipmentIds.map((id) => String(id)).join(',');
    return apiService.get(`/accounting/shipments/pre-approval-sign-statuses?shipmentIds=${encodeURIComponent(query)}`);
  },

  async rejectInvoice(shipmentId: string | number, reason: string) {
    return apiService.post(`/accounting/shipments/${shipmentId}/reject-invoice`, { reason });
  },

  async markPaid(shipmentId: string | number, receiptDocumentId?: string | number) {
    return apiService.post(`/accounting/shipments/${shipmentId}/mark-paid`, { receiptDocumentId });
  },

  async bulkEmailSignedPdf(data: { shipmentIds: Array<string | number>; recipientUserId?: string | number; recipientEmail?: string }) {
    return apiService.post('/accounting/shipments/bulk-email-signed-pdf', data);
  },

  async scanInvoiceEttn(shipmentIds: Array<string | number>, onlyMissing = true) {
    return apiService.post('/accounting/shipments/scan-invoice-ettn', { shipmentIds, onlyMissing }, { timeoutMs: 30000 });
  },

  async getEttnScanStatus() {
    return apiService.get('/accounting/shipments/scan-invoice-ettn-status', { timeoutMs: 15000 });
  },

  async undoInvoiceGroup(invoiceGroupKey: string) {
    return apiService.post('/accounting/shipments/undo-invoice-group', { invoiceGroupKey });
  },

  async setAccountingStatus(shipmentId: string | number, accountingStatus: string) {
    return apiService.post(`/accounting/shipments/${shipmentId}/set-status`, { accountingStatus });
  },
};
